import { useEffect, useState } from "react";
import api from "../../api/api";
import { toast } from "react-toastify";
import { setLoading } from "../../store/slice/utilSlice";
import { useAppDispatch } from "../../store/store";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useTranslation } from "react-i18next";

const EditProfile = () => {
    const [parentData, setParentData] = useState<any>({
        name:"",
        email: "",
        ic: "",
        birthday: new Date(),
        profile_pic: "/assets/img/default-profile.jpg",
        phone: "",
        gender: "<",
    })
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [innerLoading, setInnerLoading] = useState(false)
    const { t } = useTranslation()
    
    useEffect(() => {
        getParentDetail()
    }, [])
    
    
    const getParentDetail = async () => {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`, {
            headers: {
                "Authorization": localStorage.getItem("token"),
                "Content-Type": "application/json"
            }
        }).then( res => {
            console.log("parent", res.data.data)
            setParentData({
                name: res.data.data.name,
                email: res.data.data.email,
                phone: res.data.data.phone,
                ic: res.data.data.ic_number,
                gender: res.data.data.gender || "M",
                birthday: res.data.data.birthday || new Date(),
                profile_pic: res.data.data.profile_pic || "/assets/img/default-profile.jpg" 
            })
        }).catch( err => {
            console.log("err", err)
            alert("Server Error")
        }).finally(() => {
            dispatch(setLoading(false))
        })
    }

    const updateParent = async () => {
        if (!parentData.phone) return toast.warn("Phone number required")
            
        dispatch(setLoading(true))
        const date = new Date(parentData.birthday)
        const formattedDate = date.toLocaleDateString("en-CA")

        let payload : any = {
            "name": parentData.name,
            "ic_number": parentData.ic,
            "birthday": formattedDate,
            // "email": parentData.email,
            "gender": parentData.gender,
            "phone": parentData.phone,
        }

        // Check if profile_pic is Base64 data
        if (parentData.profile_pic.startsWith("data:")) {
            payload["profile_pic"] = parentData.profile_pic
        }

        api.put(`${process.env.REACT_APP_API_BASE_URL}/user/profile`, payload ,{
            headers: {
                "Authorization": localStorage.getItem("token"),
                "Content-Type": "application/json"
            }
        }).then( res => {
            console.log("res", res.data)
            toast.success("Updated Succesfully")
        }).catch( err => {
            console.log("err", err)
            toast.error("Server Error")
        }).finally(() => {
            getParentDetail()
        })
    }

    const handleImageChange = (e:any) => {
        const file = e.target.files[0];
        if (file) {
            const validExtensions = ["image/jpeg", "image/png", "image/jpg"]
            if (!validExtensions.includes(file.type)) return toast.error("Only JPG and PNG images are allowed.")

            const maxFileSize = 3 * 1024 * 1024 // 1 MB in bytes
            if (file.size > maxFileSize) return toast.error("Image size should not exceed 3 MB")
                
            const reader = new FileReader();
            reader.onloadend = () => {
                setParentData((prevData:any) => ({
                    ...prevData,
                    profile_pic: reader.result,
                }));
            };
            reader.readAsDataURL(file)
        }
    }

    function onChangeSelect(field: string, value: any) {
        setParentData((prev:any) => ({
            ...prev,
            [field] : value
        }))
    }


    return (
        <>
        <div className="pb-28">
            <div className='mb-2 grid grid-cols-4 px-2'>
                <div><IoIosArrowBack size={28} color='#000' onClick={()=>navigate("/profile")}/></div>
                <div className='text-center col-span-2 text-lg font-medium'>{t("profile.edit.title")}</div>
                <div></div>
            </div>
        
            <div className="mt-7">
                <div className="container">
                    <div className="flex flex-col items-center">
                        <div className="relative" style={{ height: "120px", width: "8rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={parentData.profile_pic || "/default-profile.png"} className="img-fluid" alt={t("profile.edit.altProfileImage")} style={{ height: "100%", width: "100%", borderRadius: "50%", objectFit: "cover" }} />
                            <button className="absolute bottom-1 right-1 bg-theme text-white rounded-full px-2.5 py-0.5 shadow-md" onClick={() => document.getElementById("fileInput")!.click()} > + </button>
                            <input id="fileInput" type="file" accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleImageChange} />
                        </div>
                        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                            <p className="name">{t("profile.edit.uploadPicture")}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="py-4 px-3 shadow-lg rounded-2xl">
                                <form>
                                    <div className="mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.fullName")}</label>
                                        <input type="text" value={parentData.name} onChange={(e) => setParentData((prev:any) => ({ ...prev, name: e.target.value })) } placeholder={t("profile.edit.fullName")} className="w-full px-4 py-3 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.email")}</label>
                                        <input type="text" disabled value={parentData.email} placeholder={t("profile.edit.email")} className="w-full px-4 py-3 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.phone")}</label>
                                        <input type="text" value={parentData.phone} onChange={(e) => setParentData((prev:any) => ({ ...prev, phone: e.target.value })) } placeholder={t("profile.edit.phone")} className="w-full px-4 py-3 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                    </div>
                                    
                                    <div className="relative mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.nridPassport")}</label>
                                        <select className="w-full px-4 py-3 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none">
                                            <option value="" disabled>{t("profile.edit.nridPassport")}</option>
                                            <option value="nrid">{t("profile.edit.nrid")}</option>
                                            <option value="passport">{t("profile.edit.passport")}</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.identificationNumber")}</label>
                                        <input type="text" value={parentData.ic} onChange={(e) => setParentData((prev:any) => ({ ...prev, ic: e.target.value }))} placeholder={t("profile.edit.identificationNumber")} className="w-full px-4 py-3 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.birthday")}</label>
                                        <DatePicker 
                                            onChange={(date) => setParentData((prev:any) => ({ ...prev, birthday: date }))}
                                            value={new Date(parentData.birthday)}
                                            format="yyyy-MM-dd"
                                            className="min-w-full px-4 py-3 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme"
                                        />
                                    </div>

                                    <div className="relative mb-3">
                                        <label className="text-md font-medium mb-2">{t("profile.edit.gender")}</label>
                                        <select value={parentData.gender} onChange={(e) => onChangeSelect("gender", e.target.value)} className="w-full px-4 py-3 border rounded-full text-md bg-white focus:outline-none focus:ring-2 focus:ring-theme appearance-none">
                                            <option value="" disabled>{t("profile.edit.gender")}</option>
                                            <option value="M">{t("profile.edit.male")}</option>
                                            <option value="F">{t("profile.edit.female")}</option>
                                        </select>
                                    </div>
                                    
                                    <button type="button" className="text-white text-[16px] leading-none w-full py-[15px] bg-theme border-none rounded-3xl flex items-center justify-center" onClick={() => { updateParent() }}>
                                        {innerLoading ? (
                                            <FaSpinner className="animate-spin" />
                                        ) : t("profile.edit.save")}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default EditProfile;
